/**
 * Returns a new array with values from index to numberToRemove removed and newValues inserted.
 */
export function splice<T>(arr: readonly T[], index: int, numberToRemove: int = 0, ...newValues: T[]): T[] {
  if (index < 0 || index >= arr.length) {
    throw new Error('Index for splicing must be greater than zero and less than the max index of the array.');
  }

  return [
    ...arr.slice(0, index),
    ...newValues,
    ...arr.slice(index + numberToRemove)
  ];
}